/**
 * String Template
 *
 * this is a port from the PHP version (StringTemplate class)
 *
 * @class StringTemplate
 * @author EN GARDE
 * @version 1
 * @requires lodash
 * @requires JsHelper
 */

var EN = EN || {};

EN.StringTemplate = (function (_, JsHelper) {
  'use strict';

  /** @constructor */
  function StringTemplate(options) {
    var that = this;

    that.options = $.extend({}, that.defaults, options);
    that.vars = {};
  }

  /**
   * This is a public property.
   * @memberof StringTemplate
   */
  StringTemplate.prototype.defaults = {
    prefix: '{{',
    suffix: '}}',
  };

  /**
   * Remove all previously set variables
   * @memberof StringTemplate
   */
  StringTemplate.prototype.clearVars = function () {
    var that = this;
    that.vars = {};
  };

  /**
   * Add a variable that should replace {{name}} in the template string
   * @memberof StringTemplate
   * @param string name search for {{name}}
   * @param mixed value value to replace with
   */
  StringTemplate.prototype.setVar = function (name, value) {
    var that = this;
    that.vars[name] = value;
  };

  /**
   * Add multiple variables at once
   * @memberof StringTemplate
   * @param object data name, value pairs
   * @property string name search for {{name}}
   * @property mixed value value to replace with
   */
  StringTemplate.prototype.setVars = function (data) {
    var that = this;
    if (_.isEmpty(data) || !_.isObject(data)) return;

    _.forEach(data, function (value, name) {
      that.setVar(name, value);
    });
  };

  /**
   * Return a previously set variable
   * @memberof StringTemplate
   * @param string name search for {{name}}
   */
  StringTemplate.prototype.getVar = function (name) {
    var that = this;
    if (!_.isUndefined(that.vars[name])) return that.vars[name];
  };

  /**
   * Parse Template String and return string with all variables replaced
   * @memberof StringTemplate
   * @param string templateString the string
   */
  StringTemplate.prototype.getParsedTemplateString = function (templateString) {
    var that = this;

    if (!_.isEmpty(that.vars) && _.isString(templateString)) {
      _.forEach(that.vars, function (value, name) {
        var regex = new RegExp(
          JsHelper.pregQuote(that.options.prefix) + name + JsHelper.pregQuote(that.options.suffix),
          'g'
        );
        templateString = templateString.replace(regex, value);
      });
    }

    return templateString;
  };

  return StringTemplate;
})(lodash, EN.JsHelper);
